module.exports = __webpack_public_path__ + "img/2_2-commerciale-stadio-0.fe9f96de.png";